module.exports = __webpack_public_path__ + "ptc_momoro_D2.bb22a3d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_D2.jpg
// module id = nxIw
// module chunks = 0